import axios from 'axios';

const $authHost = axios.create({
  // baseURL: 'http://localhost:3001',
  baseURL: import.meta.env.VITE_APP_API_URL as string,
});

const setAccessToken = (accessToken: string) => {
  $authHost.interceptors.request.clear();
  $authHost.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  });
};

export { $authHost, setAccessToken };
